import defaultApi from '@/utils/request';

export default {
  // 加載列表
  Get_ParentStatus(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S31/Get_ParentStatus',
      params,
    });
  },
  S31W4001_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S31/S31W4001_Load',
      params,
    });
  },
  S31W4002_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S31/S31W4002_Load',
      params,
    });
  },
  S31W4003_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S31/S31W4003_Load',
      params,
    });
  },
  S31W4004_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S31/S31W4004_Load',
      params,
    });
  },
  S31W4005_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S31/S31W4005_Load',
      params,
    });
  },
  S31W4005_GetSelfImp(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S31/S31W4005_GetSelfImp',
      params,
    });
  },
  S31W4005_finishOk(data) {
    return defaultApi({
      method: 'post',
      url: 'S01/S31/S31W4005_finishOk',
      data,
    });
  },
  S31W4005_finishStr(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S31/S31W4005_finishStr',
      params,
    });
  },
  S31W4005_readOk(data) {
    return defaultApi({
      method: 'post',
      url: 'S01/S31/S31W4005_readOk',
      data,
    });
  },
  S31W4005_selfImprove(data) {
    return defaultApi({
      method: 'post',
      url: 'S01/S31/S31W4005_selfImprove',
      data,
    });
  },
  // === S31W4006 ==============================
  doGetAlertInfo(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S31/S31W4006_GetAlertInfo',
      params,
    });
  },
  doGetTutorDetail(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S31/S31W4006_GetTutorDetail',
      params,
    });
  },
  doGetMasterDetail(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S31/S31W4006_GetMasterDetail',
      params,
    });
  },
  doGetStudentDetail(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S31/S31W4006_GetStudentDetail',
      params,
    });
  },
  doGetTeacherDetail(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S31/S31W4006_GetTeacherDetail',
      params,
    });
  },
  doGetUntTeacher(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S31/S31W4006_doGetUntTeacher',
      params,
    });
  },
  doGetIntrospect(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S31/S31W4006_GetIntrospect',
      params,
    });
  },
  doGetLackRecord(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S31/S31W4006_GetLackRecord',
      params,
    });
  },
  // =========================== S31W4007 =========================
  S31W4007_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S31/S31W4007_Load',
      params,
    });
  },
  // =========================== S31W4008 =========================
  S31W4008_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S31/S31W4008_Load',
      params,
    });
  },
  // =========================== S31W2001 =========================
  S31W2001_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S31/S31W2001_Load',
      params,
    });
  },
  S31W2001_GetRequired(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S31/S31W2001_GetRequired',
      params,
    });
  },
  S31W2001_GetElective(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S31/S31W2001_GetElective',
      params,
    });
  },
  S31W2001_SaveRequired(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S31/S31W2001_SaveRequired',
      data,
    });
  },
  S31W2001_SaveElective(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S31/S31W2001_SaveElective',
      data,
    });
  },
  S31W2001_GetApplyHistory(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S31/S31W2001_GetApplyHistory',
      params,
    });
  },
  S31W2001_SaveEdit(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S31/S31W2001_SaveEdit',
      data,
    });
  },
  S31W2001_LoadPrintPDFData(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S31/S31W2001_LoadPrintPDFData',
      responseType: 'blob',
      params,
    });
  },
  // ======================== S31W2002 =====================================
  S31W2002_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S31/S31W2002_Load',
      params,
    });
  },
  S31W2002_LoadGradeWeightConfig(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S31/S31W2002_LoadGradeWeightConfig',
      params,
    });
  },
  S31W2002_LoadRegularAssessment(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S31/S31W2002_LoadRegularAssessment',
      params,
    });
  },
  S31W2002_LoadMidtermAssessment(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S31/S31W2002_LoadMidtermAssessment',
      params,
    });
  },
  S31W2002_LoadFinalAssessment(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S31/S31W2002_LoadFinalAssessment',
      params,
    });
  },
  S31W2002_SaveGradeWeightConfig(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S31/S31W2002_SaveGradeWeightConfig',
      data,
    });
  },
  S31W2002_SaveRegularAssessment(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S31/S31W2002_SaveRegularAssessment',
      data,
    });
  },
  S31W2002_SaveMidtermAssessment(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S31/S31W2002_SaveMidtermAssessment',
      data,
    });
  },
  S31W2002_SaveFinalAssessment(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S31/S31W2002_SaveFinalAssessment',
      data,
    });
  },
  S31W2002_SaveReasonSuggestion(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S31/S31W2002_SaveReasonSuggestion',
      data,
    });
  },
  S31W2002_SendReg(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S31/S31W2002_SendReg',
      data,
    });
  },
  S31W2002_SaveCounseling(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S31/S31W2002_SaveCounseling',
      data,
    });
  },
  S31W2002_LoadPrintPDFData(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S31/S31W2002_LoadPrintPDFData',
      responseType: 'blob',
      params,
    });
  },
  S31W2002_LoadAlertConfig(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S31/S31W2002_LoadAlertConfig',
      params,
    });
  },
  S31W2002_LoadReasonSuggestion(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S31/S31W2002_LoadReasonSuggestion',
      params,
    });
  },
  S31W2002_Get_CSV_Transcript(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S31/S31W2002_Get_CSV_Transcript',
      responseType: 'blob',
      params,
    });
  },
  S31W2002_SendMidChk(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S31/S31W2002_SendMidChk',
      params,
    });
  },
  S31W2002_SendFinalChk(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S31/S31W2002_SendFinalChk',
      params,
    });
  },
  //= =======================================================================
};
